// Doc edit notes in the Style Profile (Ryan, 2026-10-05): the client's notes for every doc edit, which feed the doc edit
// AI Style Notes and nothing else (backend/app/style_notes/profile.py: video.doc_edit_notes). The ONLY place that holds
// the box's words: the profile page, the setup wizard, the order page's box, the notice and the read-only views read
// them from here.

export const DOC_EDIT_NOTES_FIELD = 'doc_edit_notes';
export const DOC_EDIT_NOTES_LABEL = 'Doc edit notes';
export const DOC_EDIT_NOTES_HINT =
  'For your doc edits only: what to keep in full, which speeches and dances, titles, sound, music. Your editor reads these on every doc edit.';
export const DOC_EDIT_NOTES_PLACEHOLDER =
  'e.g. Ceremony, speeches and first dances in full, every angle. Keep the room sound. A title for each part of the day.';
export const DOC_EDIT_NOTES_TARGET = '/style-profile#doc-edit-notes';

/** The profile's doc edit notes, trimmed ('' when there are none). */
export function docEditNotes(video) {
  const v = (video || {})[DOC_EDIT_NOTES_FIELD];
  return typeof v === 'string' ? v.trim() : '';
}

/** Is any item in this cart a doc edit (the order page's line items carry is_doc_edit)? */
export function cartHasDocEdit(items) {
  return (items || []).some(i => i && i.is_doc_edit);
}
